enum AssetDestination {
  PATIENT = 'PATIENT',
  CKEDITOR = 'CKEDITOR',
  COMMONS = 'COMMONS',
  BUSINESS = 'BUSINESS',
  PERSON = 'PERSON',
}

export default AssetDestination
